<template>
  <section class="section">
    <div class="header" @click="toggle">
      <div class="flex justify-between">
        <slot name="header">
        </slot>
        <button @click="onEdit">
          <ChevronUpIcon  v-if="open" class="icon" />
          <ChevronDownIcon v-else="open" class="icon" />
        </button>
      </div>
    </div>
    <div v-show="open" class="body">
      <slot name="default">
      </slot>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({init: {name: Boolean, default: false}});

const open = ref(props.init);

const toggle = () => open.value = !open.value;
</script>

<style scoped>
.section
{
  @apply bg-white shadow;
  @apply overflow-hidden;
  @apply sm:rounded-md;
};

.header
{
  @apply px-4 py-5 sm:px-6;
  @apply cursor-pointer
};

.body
{
  @apply border-t border-gray-200;
}

.icon
{
  @apply flex-shrink-0;
  @apply h-5 w-5;
  @apply text-gray-400
};
</style>
